import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const OpenLock: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path d="M8.75 11.25a1.25 1.25 0 1 0-1.5 0v1a.75.75 0 0 0 1.5 0v-1Z"></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 4v2h8.5a1 1 0 0 1 1 1v6a3 3 0 0 1-3 3h-7a3 3 0 0 1-3-3V7a1 1 0 0 1 1-1h1V4a4 4 0 0 1 4-4h1a4 4 0 0 1 4 4A.75.75 0 0 1 11 4a2.5 2.5 0 0 0-2.5-2.5h-1A2.5 2.5 0 0 0 5 4ZM3 7.5V13a1.5 1.5 0 0 0 1.5 1.5h7A1.5 1.5 0 0 0 13 13V7.5H3Z"
            ></path>
        </Icon>
    );
};
